// services/presence.js — Présence en ligne : ping + compteurs (total, par jeu, amis).
// Le total/par-jeu (public) vient du backend AppStore ; les compteurs d'amis (identité requise)
// viennent d'un appel Nakama direct avec la session du membre.
import { nakamaAuth } from './nakamaAuth';
import { login as deviceLogin, isExpired } from './nakamaClient';
import { nakama } from '../config/nakama';

const BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

// Token à utiliser pour ping/RPC : celui du MEMBRE si connecté (pour que ses amis le voient),
// sinon un token invité (device) pour compter aussi les visiteurs.
async function _token() {
  const s = nakamaAuth.session;
  // Token membre valide → on l'utilise (pour que ses amis le voient en ligne). S'il est périmé,
  // on retombe sur un token invité frais plutôt que de spammer des 401 avec un token mort.
  if (s && s.token && s.token !== 'local-guest' && !isExpired(s.token)) return s.token;
  try { return await deviceLogin(); } catch { return null; }
}

async function _rpc(id, payload, token) {
  if (!nakama.enabled || !token) return null;
  try {
    const res = await fetch(`${nakama.url}/v2/rpc/${id}`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
      body: JSON.stringify(JSON.stringify(payload || {})),
    });
    if (!res.ok) return null;
    const d = await res.json();
    return d && d.payload ? JSON.parse(d.payload) : null;
  } catch { return null; }
}

// Marque le joueur en ligne sur un « jeu » donné (défaut "appstore").
export async function ping(game = 'appstore') {
  const t = await _token();
  if (t) await _rpc('vg_presence_ping', { game }, t);
}

// Total + par jeu (public — marche même déconnecté).
export async function publicCounts() {
  try {
    const r = await fetch(`${BASE}/online/counts`);
    if (!r.ok) return { total: 0, games: {} };
    return await r.json();
  } catch { return { total: 0, games: {} }; }
}

// Amis en ligne + amis par jeu (uniquement si membre connecté). friends_online = LISTE des uids d'amis PRÉSENTS
// (présence par PING serveur, fenêtre ~120 s) → SOURCE DE VÉRITÉ du « en ligne » : un ami reste présent tant que son
// onglet AppStore ping (onglet ouvert + PC éveillé), immunisé aux hoquets du socket temps réel.
export async function friendCounts() {
  const s = nakamaAuth.session;
  if (!s || !s.token || s.token === 'local-guest') return { friends_total: 0, friends_by_game: {}, friends_online: [] };
  const r = await _rpc('vg_online_counts', {}, s.token);
  // IMPORTANT : si le RPC ÉCHOUE (r null : réseau/token), on renvoie friends_online = null (≠ []). Le front NE DOIT
  // PAS vider la liste sur un échec (sinon les amis clignotent) — il garde l'état précédent. [] = succès mais personne.
  return r ? { friends_total: r.friends_total || 0, friends_by_game: r.friends_by_game || {}, friends_online: Array.isArray(r.friends_online) ? r.friends_online : [] }
           : { friends_total: 0, friends_by_game: {}, friends_online: null };
}
// LISTE des uids d'amis PRÉSENTS (ping serveur). null = le RPC a échoué (à NE PAS interpréter comme « personne »).
export async function onlineFriendIds() {
  try { const r = await friendCounts(); return r.friends_online; } catch { return null; }
}
